import React from 'react';
import "../../css/Common-components/titleBar.css";

// 섹션 제목과 "모두 보기" 버튼을 함께 출력하는 공통 헤더
function TitleBar({ title, onSeeAll }) {
  return (
    <div className="title-bar">
      <h2 className="section-title">{title}</h2>
      {onSeeAll && (
        <button className="btn see-all-button" onClick={onSeeAll}>
          <span className='see-all-button-text'>모두 보기</span>
        </button>
      )}
    </div>
  );
}

export default TitleBar;
